import { render, staticRenderFns } from "./TOReasonsAdminPage.vue?vue&type=template&id=600a7bc4"
import script from "./TOReasonsAdminPage.vue?vue&type=script&lang=js"
export * from "./TOReasonsAdminPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports